<template>
  <div/>
</template>

<script setup lang="ts">
import { watch } from 'vue';
import { useStore } from 'vuex';
import { latestMessage, type WebSocketMessageWithFields, type WebSocketMessageEmpty } from '@/plugins/ws';

import {RootState} from "@/store";

const store = useStore<RootState>();

defineOptions({
  name: 'dataUserAccounts',
});

// Базовый тип для сообщений с ID аккаунта пользователя
type UserAccountWithId = {
  idUserAccount: number;
};

// Базовый тип для общих полей аккаунта пользователя
type UserAccountCommonFields = {
  type: string;
  title: string;
};

// Типы для WebSocket сообщений компонента userAccounts
type UserAccountsListMessage = WebSocketMessageWithFields<'helper-accounts' | 'helper-agents', {
  userAccounts: unknown[];
  userAccountTypes: unknown[];
}>;
type UserAccountCreateMessage = WebSocketMessageWithFields<'helper-account-create' | 'helper-account-create-success', UserAccountWithId & {
  idUser: number;
} & UserAccountCommonFields>;
type UserAccountUpdateMessage = WebSocketMessageWithFields<'helper-account-update' | 'helper-account-update-success', UserAccountWithId & UserAccountCommonFields>;
type UserAccountDeleteMessage = WebSocketMessageWithFields<'helper-account-delete' | 'helper-account-delete-success', UserAccountWithId>;

// Объединенный тип для всех сообщений
type UserAccountsWebSocketMessage = 
  | UserAccountsListMessage 
  | UserAccountCreateMessage 
  | UserAccountUpdateMessage 
  | UserAccountDeleteMessage;

// WebSocket message handler
const handleWebSocketMessage = (data: UserAccountsWebSocketMessage): void => {
  if (!data?.signal) return;

  switch (data.signal) {
    case 'helper-accounts':
    case 'helper-agents':
      store.dispatch('userAccount/wsSetUserAccounts', {
        userAccounts: data.userAccounts,
        userAccountTypes: data.userAccountTypes,
      });
      break;

    case 'helper-account-create':
    case 'helper-account-create-success':
      store.dispatch('userAccount/wsUserAccountCreate', {
        idUserAccount: data.idUserAccount,
        idUser: data.idUser,
        type: data.type,
        title: data.title,
      });
      break;

    case 'helper-account-update':
    case 'helper-account-update-success':
      store.dispatch('userAccount/wsUserAccountUpdate', {
        idUserAccount: data.idUserAccount,
        type: data.type,
        title: data.title,
      });
      break;

    case 'helper-account-delete':
    case 'helper-account-delete-success':
      store.dispatch('userAccount/wsUserAccountDelete', {
        idUserAccount: data.idUserAccount,
      });
      break;

  }
};

watch(latestMessage, handleWebSocketMessage);
</script>
